import { ReadonlyRecord } from '@bimser/core';
import { Record } from 'immutable';

interface IAIAssistantBaseState {
	visible: boolean;
	isPinned: boolean;
}

export interface IAIAssistantState extends IAIAssistantBaseState {}

export interface IReadOnlyAIAssistantState extends IAIAssistantBaseState {}

export type AIAssistantState = ReadonlyRecord<IReadOnlyAIAssistantState>;

export const AIAssistantStateFactory = Record<IReadOnlyAIAssistantState>({
	visible: false,
	isPinned: false
});

export const AIAssistantStateFactoryFromJS = function (data: IAIAssistantState) {
	return AIAssistantStateFactory(data);
};
